import { FunctionComponent, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import { preInitialSyncRoutes } from '~/client/config/routes';
import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

import { AppContainerRoot } from './AppContainer.styled';
import { useDetectIsOnCamdenNetwork } from './useDetectIsOnCamdenNetwork';
import { useDetectNeedsClientAuth } from './useDetectNeedsClientAuth';
import { useEnsureHasActiveSession } from './useEnsureHasActiveSession';
import { useEnsureHasPageAccess } from './useEnsureHasPageAccess';
import { useEnsureHasRegisteredUser } from './useEnsureHasRegisteredUser';
import { useFocusHeading } from './useFocusHeading';
import { useFollowUrlHash } from './useFollowUrlHash';
import { useManageSyncStores } from './useManageSyncStores';
import { useRecordPreviousPathname } from './useRecordPreviousPathname';
import { useScrollToTop } from './useScrollToTop';
import { useUserAnalytics } from './useUserAnalytics';

const preSyncPaths: string[] = Object.values(preInitialSyncRoutes);

export const AppContainer: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { pathname } = useLocation();

  const hasCompletedInitialSync = useTinybaseStore((state) => state.hasCompletedInitialSync);

  const canRenderChildren = hasCompletedInitialSync || preSyncPaths.includes(pathname);

  useEnsureHasRegisteredUser();
  useEnsureHasPageAccess();
  useEnsureHasActiveSession();
  useDetectIsOnCamdenNetwork();
  useDetectNeedsClientAuth();
  useManageSyncStores();
  useScrollToTop();
  useFocusHeading();
  useFollowUrlHash();
  useRecordPreviousPathname();
  useUserAnalytics();

  return <AppContainerRoot>{canRenderChildren && children}</AppContainerRoot>;
};
